import { render, staticRenderFns } from "./WtHeader.vue?vue&type=template&id=4821825c&"
import script from "./WtHeader.vue?vue&type=script&lang=ts&"
export * from "./WtHeader.vue?vue&type=script&lang=ts&"
import style0 from "./WtHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports